import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';

import Button from './Button';
import Style from '../../styles/common';

function SubmitButton(props) {
  return <Button {...props} type="submit">{props.children}</Button>;
}

SubmitButton.propTypes = {
  children: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
};

SubmitButton.defaultProps = {
  disabled: false,
  loading: false,
};

export default SubmitButton;



// WEBPACK FOOTER //
// ./src/components/Buttons/SubmitButton.js